import { useState } from 'react';

interface ExternalIconProps {
  style?: any;
}

export const ExternalIcon: React.FC<ExternalIconProps> = (props) => {
  const { style } = props;
  const [isHover, setIsHover] = useState<boolean>(false);

  const onMouseIn = () => {
    setIsHover(true);
  };

  const onMouseOut = () => {
    setIsHover(false);
  };

  return (
    <svg
      style={{
        strokeLinejoin: 'round',
        color: isHover ? '#007eb9' : '#16191F',
        strokeWidth: '2px',
        width: '14px',
        height: '14px',
        fill: 'none',
        ...style,
      }}
      onMouseEnter={onMouseIn}
      onMouseLeave={onMouseOut}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      focusable="false"
      aria-hidden="true"
    >
      <path d="M10 2h4v4"></path>
      <path d="M6 10l8-8"></path>
      <path d="M14 9.048V14H2V2h5"></path>
    </svg>
  );
};

export default ExternalIcon;
